<template>
  <span class="spinner-border flex-shrink-0" role="status" style="width: 16px; height: 16px">
    <span class="visually-hidden">Loading...</span>
  </span>
</template>

<script setup></script>
